import React from "react";

export default function SocialIcon({ className = "w-6 h-6" }) {
    return (
        <div className={className}>
            <svg
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-full h-full"
            >
                <defs>
                    <linearGradient id="social_wing_blue" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#60a5fa" />
                        <stop offset="100%" stopColor="#2563eb" />
                    </linearGradient>
                    <linearGradient id="social_wing_purple" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#a78bfa" />
                        <stop offset="100%" stopColor="#7c3aed" />
                    </linearGradient>
                    <linearGradient id="social_wing_pink" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#f472b6" />
                        <stop offset="100%" stopColor="#db2777" />
                    </linearGradient>
                </defs>

                <g>
                    {/* Bottom Swoosh (Pink) */}
                    <path
                        d="M8 28C8 28 12 34 20 34C28 34 34 26 34 26"
                        stroke="url(#social_wing_pink)"
                        strokeWidth="4"
                        strokeLinecap="round"
                        className="opacity-90"
                    />

                    {/* Middle Swoosh (Purple) */}
                    <path
                        d="M10 20C10 20 14 26 22 26C30 26 36 16 36 16"
                        stroke="url(#social_wing_purple)"
                        strokeWidth="4"
                        strokeLinecap="round"
                        className="opacity-95"
                    />

                    {/* Top Swoosh (Blue) */}
                    <path
                        d="M12 12C12 12 16 18 24 18C32 18 38 6 38 6"
                        stroke="url(#social_wing_blue)"
                        strokeWidth="4"
                        strokeLinecap="round"
                    />
                </g>
            </svg>
        </div>
    );
}
